import { OrderPayableBy, OrderPayableTo } from "../../../../views/Orders/enums";

type PayableByValue = OrderPayableBy | "";
type PayableToValue = OrderPayableTo | "";

const payableByShortLabel: Record<OrderPayableBy, string> = {
  [OrderPayableBy.CUSTOMER]: "C",
  [OrderPayableBy.INSURANCE]: "I",
  [OrderPayableBy.NBFC]: "N",
};

const payableToShortLabel: Record<OrderPayableTo, string> = {
  [OrderPayableTo.GARAAZ]: "G",
  [OrderPayableTo.SUPPLIER]: "S",
};

export const getFullPaymentRouteLabel = (
  payableBy?: PayableByValue,
  payableTo?: PayableToValue,
): { from: string; to: string } => {
  if (!payableBy || !payableTo) return { from: "-", to: "-" };
  return { from: payableBy, to: payableTo };
};

export const getShortPaymentRouteLabel = (
  payableBy?: PayableByValue,
  payableTo?: PayableToValue,
): { from: string; to: string } => {
  if (!payableBy || !payableTo) return { from: "-", to: "-" };
  return {
    from: payableByShortLabel[payableBy] ?? "-",
    to: payableToShortLabel[payableTo] ?? "-",
  };
};
